/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The QR Code type enumeration.
 */
export enum QrCodeType {
    UNDEFINED = 'undefined',
    PERSON = 'person',
    VISIT = 'visit',
    INVESTIGATION_DEMAND = 'investigationDemand',
    LABORATORY_TEST = 'laboratoryTest',
    TREATMENT = 'treatment',
    MEDICAL_RECEIPT = 'medicalReceipt',
    PREGNANT_MONITORING_INFO = 'pregnantMonitoringInfo',
    STOCK_INTERNAL_INQUIRY = 'stockInternalInquiry',
    STOCK_INTERNAL_ISSUANCE = 'stockInternalIssuance',
    STOCK_INTERNAL_ENTRY = 'stockInternalEntry',
    STOCK_INTERNAL_RETURN = 'stockInternalReturn',
    STOCK_INTERNAL_CONSUMPTION = 'stockInternalConsumption',
    STOCK_NATIONAL_INQUIRY = 'stockNationalInquiry',
    STOCK_NATIONAL_ISSUANCE = 'stockNationalIssuance',
    STOCK_NATIONAL_ENTRY = 'stockNationalEntry',
    STOCK_NATIONAL_RETURN = 'stockNationalReturn',
    STOCK_NATIONAL_CONSUMPTION = 'stockNationalConsumption',
    EPIDEMIOLOGY_CASE = 'epidemiologyCase',
    CONSULTATION_EXAMINATION = 'consultationExamination',
    SCREENING_EXAMINATION = 'screeningExamination',
    REPORT = 'report',
    SPECIMEN = 'specimen',
    SPECIMEN_INVESTIGATION = 'specimenInvestigation',
}
